import { connect } from 'react-redux';
import TermsAndConditions from './termsandconditions';
import { acceptsodTnC } from '../../../services/tnc';
import { hideNavBar, showNavBar } from '../../../services/ui';

const mapState = () => ({});

const mapDispatch = {
  hideNavBar: () => dispatch => dispatch(hideNavBar()),
  showNavBar: () => dispatch => dispatch(showNavBar()),
  acceptsodTnC,
};

export default connect(
  mapState,
  mapDispatch,
)(TermsAndConditions);
